import { ChangeEvent, FC, useContext, useEffect, useState } from "react";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { AddNoteProps, saveNoteApiResponseType } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { AuthContext } from "src/context/authContext";
import { format } from "date-fns";



const AddNote: FC<AddNoteProps> = ({ isModalVisible, caseId, hideModal, refreshListing}): JSX.Element => {
  const [treatmentDate, changeTreatmentDate] = useState<Date | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isInvalid, setInvalidStatus] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [noteDate, changeNoteDate] = useState<string>("");
  const [notes, setNote] = useState<string>('');
  const {isManufacturer}=useContext(AuthContext)
  const { data: saveNoteData, mutate: saveNoteMutate, error: saveNoteError } = useFetch<saveNoteApiResponseType>(APIEndpoints.SAVE_NOTE, {}, {},false)
  const { showToast } = useContext(ToastContext);

  const onChangeSelect = (value:ChangeEvent<HTMLSelectElement>) => {
    setNote(value.target.value);
  };

  const saveNotes = () => {
      const requestBody = {
        "ref_id": caseId, // case id, wrt case
        "ref_type":isManufacturer ? "MfgrCase" :'Case', // always this
        "description": notes,
        ...(treatmentDate ? {
          "note_date": format(treatmentDate, "yyyy-MM-dd") // year-month-day
        } : {})
      }
      //console.log("Save Notes.......",requestBody)
      saveNoteMutate(requestBody)
  };

  useEffect(() => {
    if (saveNoteData || saveNoteError) {
      hideModal()
      if(saveNoteData){
        const { code } = saveNoteData;
        if (code === 200) {
          showToast([`Notes Save Successfully`], ToastTypes.SUCCESS);

          refreshListing(saveNoteData.data)
        }
      }

    }
    return(()=>{
      setNote('')
      changeNoteDate('')
      changeTreatmentDate(null)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveNoteData, saveNoteError]);

  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''} loader-index`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title mb-0" id="exampleModalLabel">
              New Note For Case {caseId}
            </h3>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">
            <p className="text-center "> Please specify note and date... </p>

            <div className="row my-2 align-items-center">
              <div className="col-3 text-end">
                <label htmlFor="note_description" className="form-label mb-0">Note *</label>
              </div>
              <div className="col-7">
                <select className="form-select" id="note_description" value={notes} onChange={onChangeSelect}>
                  <option value="">Select a note...</option>
                  <option value="Scheduled">Scheduled</option>
                  <option value="Need to Schedule">Need to Schedule</option>
                  <option value="Need to Re-run">Need to Re-run</option>
                  <option value="Pending Specialty Pharmacy">Pending Specialty Pharmacy</option>
                  <option value="Pending Prior Authorization Approval">Pending Prior Authorization Approval</option>
                  <option value="Requires Office Attention">Requires Office Attention</option>
                  <option value="Office Authorization Required">Office Authorization Required</option>
                  <option value="Copay Card Needed">Copay Card Needed</option>
                  <option value="Third Party Block">Third Party Block</option>
                  <option value="Patient Needs to Call Pharmacy">Patient Needs to Call Pharmacy</option>
                  <option value="Unable to Reach Patient">Unable to Reach Patient</option>
                  <option value="Office Need to Call Pharmacy">Office Need to Call Pharmacy</option>
                  <option value="Offices Needs to Verify Fee Schedule">Offices Needs to Verify Fee Schedule</option>
                  <option value="Office Needs to Update Insurance">Office Needs to Update Insurance</option>
                  <option value="Pending P&amp;T Approval">Pending P&amp;T Approval</option>
                  <option value="Pre-Certification Required">Pre-Certification Required</option>
                </select>
              </div>
            </div>

            <div className="row my-2 align-items-center">
              <div className="col-3 text-end">
                <label htmlFor="noteDate" className="form-label mb-0">Date</label>
              </div>
              <div className="col-7">
                {/* <input
                  type="date"
                  value={noteDate}
                  onChange={(e) => changeNoteDate(e.target.value)}
                  name="noteDate"
                  id="noteDate"
                  className="form-control"
                /> */}
                 <DatePicker
                    selected={treatmentDate}
                    onChange={(date) => changeTreatmentDate(date || null)}
                    dateFormat="MM/dd/yyyy"
                    className={`form-control ${isInvalid ? "is-invalid" : ""}`}
                    placeholderText="mm/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    customInput={
                      <ReactInputMask mask="99/99/9999">
                        {(inputProps: {}) => <input {...inputProps} />}
                      </ReactInputMask>
                    }
                    //maxDate={bentype === "med" ? new Date() : undefined}
                    wrapperClassName="w-100"
                />
                {isInvalid && (
                  <p className="mb-0 text-danger pt-1">Date is required</p>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={saveNotes}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNote;
